import { Box, Button, ButtonGroup } from '@mui/material';
import Image from '@tiptap/extension-image';
import Link from '@tiptap/extension-link';
import TextAlign from '@tiptap/extension-text-align';
import Underline from '@tiptap/extension-underline';
import { EditorContent, useEditor } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import React, { useEffect } from 'react';

const TiptapEditor = ({ content, onChange }) => {
  const editor = useEditor({
    extensions: [
      StarterKit,
      Underline,
      Link.configure({ openOnClick: false }),
      Image,
      TextAlign.configure({ types: ['heading', 'paragraph'] }),
    ],
    content,
    onUpdate: ({ editor }) => {
      const html = editor.getHTML();
      onChange(html);
    },
  });

  useEffect(() => {
    if (editor && content && editor.getHTML() !== content) {
      editor.commands.setContent(content);
    }
  }, [content]);

  if (!editor) return null;

  return (
    <Box
      sx={{
        border: '1px solid #ccc',
        borderRadius: 2,
        padding: 2,
        backgroundColor: 'background.paper',
        mt: 1,
      }}
    >
      <ButtonGroup
        variant='outlined'
        size='small'
        sx={{ mb: 2, flexWrap: 'wrap' }}
      >
        <Button
          onClick={() => editor.chain().focus().toggleBold().run()}
          disabled={!editor.can().chain().focus().toggleBold().run()}
        >
          Félkövér
        </Button>
        <Button
          onClick={() => editor.chain().focus().toggleItalic().run()}
          disabled={!editor.can().chain().focus().toggleItalic().run()}
        >
          Dőlt
        </Button>
        <Button
          onClick={() => editor.chain().focus().toggleUnderline().run()}
          disabled={!editor.can().chain().focus().toggleUnderline().run()}
        >
          Aláhúzás
        </Button>
        <Button
          onClick={() => editor.chain().focus().setTextAlign('left').run()}
        >
          Balra
        </Button>
        <Button
          onClick={() => editor.chain().focus().setTextAlign('center').run()}
        >
          Középre
        </Button>
        <Button
          onClick={() => editor.chain().focus().setTextAlign('right').run()}
        >
          Jobbra
        </Button>
        <Button
          onClick={() => editor.chain().focus().setTextAlign('justify').run()}
        >
          Sorkizárt
        </Button>
        <Button
          onClick={() => {
            const url = window.prompt('Kép URL címe');
            if (url) editor.chain().focus().setImage({ src: url }).run();
          }}
        >
          Kép
        </Button>
        <Button
          onClick={() => {
            const url = window.prompt('Link URL címe');
            if (url) editor.chain().focus().toggleLink({ href: url }).run();
          }}
        >
          Link
        </Button>
      </ButtonGroup>

      <Box
        sx={{
          minHeight: '300px',
          border: '1px solid #ddd',
          borderRadius: 1,
          padding: 1,
          '& .ProseMirror': {
            outline: 'none',
            minHeight: '250px',
          },
        }}
      >
        <EditorContent editor={editor} />
      </Box>
    </Box>
  );
};

export default TiptapEditor;
